import { render, staticRenderFns } from "./SocialFeedView.vue?vue&type=template&id=e84b705c&"
import script from "./SocialFeedView.vue?vue&type=script&lang=js&"
export * from "./SocialFeedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports